import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Shield, Menu, X } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import translations from '../i18n/translations';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { lang, toggleLang, isRTL } = useLang();
  const t = translations[lang].nav;

  const navLinks = [
    { label: t.home, path: '/' },
    { label: t.useCases, path: '/use-cases' },
    //Features
     { label: t.Features, path: '/Features' },
    { label: t.pricing, path: '/pricing' },
    { label: t.about, path: '/about' },
    { label: t.contact, path: '/contact' },
  ];

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="navbar__inner container">
        <Link to="/" className="navbar__logo">
          <Shield size={22} className="navbar__logo-icon" />
          <span>KYCPro<span className="navbar__logo-ai">.AI</span></span>
        </Link>

        <ul className="navbar__links">
          {navLinks.map(link => (
            <li key={link.path}>
              <Link
                to={link.path}
                className={`navbar__link ${location.pathname === link.path ? 'navbar__link--active' : ''}`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>

        <div className="navbar__actions">
          <button className="lang-toggle" onClick={toggleLang} title="Switch Language">
            <span className={`lang-toggle__option ${!isRTL ? 'lang-toggle__option--active' : ''}`}>EN</span>
            <span className="lang-toggle__sep">|</span>
            <span className={`lang-toggle__option ${isRTL ? 'lang-toggle__option--active' : ''}`}>ع</span>
          </button>
          <Link to="/contact" className="btn-primary navbar__cta">
            {t.getStarted}
          </Link>
        </div>

        <button className="navbar__burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <div className={`navbar__mobile ${menuOpen ? 'navbar__mobile--open' : ''}`}>
        {navLinks.map(link => (
          <Link
            key={link.path}
            to={link.path}
            className={`navbar__mobile-link ${location.pathname === link.path ? 'navbar__mobile-link--active' : ''}`}
          >
            {link.label}
          </Link>
        ))}
        <div className="navbar__mobile-bottom">
          <button className="lang-toggle" onClick={toggleLang}>
            <span className={`lang-toggle__option ${!isRTL ? 'lang-toggle__option--active' : ''}`}>EN</span>
            <span className="lang-toggle__sep">|</span>
            <span className={`lang-toggle__option ${isRTL ? 'lang-toggle__option--active' : ''}`}>ع</span>
          </button>
          <Link to="/contact" className="btn-primary" style={{ flex: 1, justifyContent: 'center' }}>
            {t.getStarted}
          </Link>
        </div>
      </div>
    </nav>
  );
}
